export const Routes = {
  HOME: '/home',
  TEST: '/test',
  LOGIN: '/auth',
  CMS_NEW:'/setting/news',
  CMS_NEWS_ITEM:'/setting/news/item',
  CMS_GALLERY:'/setting/gallery',
  CMS_PRODUCTS:'/setting/products',
  CMS_PRODUCT_ITEM:'/setting/product/item',
	CMS_CONTACTS: '/setting/contacts'
}